// src/pages/Production/Reports.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
    container: { 
        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: 'transparent'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '32px'
    },
    title: {
        fontSize: '32px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0,
        letterSpacing: '-0.5px'
    },
    box: { 
        background: 'white', 
        padding: '32px', 
        borderRadius: '16px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e2e8f0',
        marginBottom: '30px'
    },
    reportCard: {
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '25px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        transition: 'all 0.2s ease',
        cursor: 'pointer'
    },
    reportCardHover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    },
    reportIcon: {
        fontSize: '32px',
        marginBottom: '15px'
    },
    reportTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#0f172a',
        margin: '0 0 10px 0'
    },
    reportDescription: {
        fontSize: '14px',
        color: '#64748b',
        margin: 0
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '25px'
    }
};

function Reports() {
    const navigate = useNavigate();
    const [hoveredCard, setHoveredCard] = useState(null);

    const reports = [
        {
            id: 'production-status',
            title: 'Üretim Durum Raporu',
            description: 'Planlanan, devam eden ve tamamlanan üretim emirlerinin durumu',
            icon: '📋',
            path: '/uretim/raporlar/uretim-durum'
        },
        {
            id: 'raw-material-stock',
            title: 'Hammadde Stok Durumu',
            description: 'Hammaddelerin stok seviyeleri ve kritik stok uyarıları',
            icon: '📦',
            path: '/uretim/raporlar/hammadde-stok'
        },
        {
            id: 'subcontractor-production',
            title: 'Fason Bazlı Üretim Raporu',
            description: 'Fasonculara verilen üretim emirlerinin durumu ve maliyetleri',
            icon: '🏭',
            path: '/uretim/raporlar/fason-uretim'
        },
        {
            id: 'subcontractor-balance',
            title: 'Fason Bakiyesi ve Maliyet Özeti',
            description: 'Fasoncuların bakiyeleri ve yapılan ödemeler',
            icon: '💰',
            path: '/uretim/raporlar/fason-bakiye'
        },
        {
            id: 'product-cost',
            title: 'Ürün Bazlı Maliyet Analizi',
            description: 'Ürünlerin maliyet dağılımı ve kâr marjları',
            icon: '📊',
            path: '/uretim/raporlar/urun-maliyet'
        },
        {
            id: 'waste-report',
            title: 'Üretim Emri Bazlı Fire Raporu',
            description: 'Üretim aşamalarında oluşan fire miktarları',
            icon: '🔥',
            path: '/uretim/raporlar/fire-raporu'
        }
    ];

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <div>
                    <h1 style={styles.title}>Üretim Raporları</h1>
                    <p style={{ color: '#64748b', marginTop: '4px' }}>
                        Detaylı üretim raporları ve analizler
                    </p>
                </div>
            </div>

            <div style={styles.box}>
                <h3 style={{...styles.title, fontSize: '20px', marginBottom: '25px'}}>Raporlar</h3>
                
                <div style={styles.grid}>
                    {reports.map(report => (
                        <div 
                            key={report.id}
                            style={{
                                ...styles.reportCard,
                                ...(hoveredCard === report.id ? styles.reportCardHover : {})
                            }}
                            onMouseEnter={() => setHoveredCard(report.id)}
                            onMouseLeave={() => setHoveredCard(null)}
                            onClick={() => navigate(report.path)}
                        >
                            <div style={styles.reportIcon}>{report.icon}</div>
                            <h4 style={styles.reportTitle}>{report.title}</h4>
                            <p style={styles.reportDescription}>{report.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            
            <div style={styles.box}>
                <h3 style={{...styles.title, fontSize: '20px', marginBottom: '20px'}}>Rapor Seçenekleri</h3>
                <p style={{ color: '#64748b', marginBottom: '20px' }}>
                    Raporlar PDF, Excel veya ekrana tablo olarak alınabilir.
                </p>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <button style={{
                        padding: '12px 24px',
                        background: '#10b981',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        📄 PDF Olarak İndir
                    </button>
                    <button style={{
                        padding: '12px 24px',
                        background: '#3b82f6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        📊 Excel Olarak İndir
                    </button>
                    <button style={{
                        padding: '12px 24px',
                        background: '#8b5cf6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        🖨️ Yazdır
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Reports;